import * as actions from '../actions/actionTypes';
import * as eventTypes from '../utils/eventTypes';
import { IMatchesState, IState } from '../store/state';
import { IMatchEventsFeed, IMatchEvent, IMatchEventMatch } from '../types/IMatchEventsFeed';
 
const mapScoreObject = {
    0: 0,
    1: 15,
    2: 30,
    3: 40,
    4: 40
};

let nthObject = {};

export const EVENT_MATCH_ENDED: string = '20';
export const STATUS_MATCH_ENDED: string = '100';

// TODO: implement Ranking feed and write all informations in the match object

const matches = ( state: IMatchesState = {}, action: any ) : IMatchesState => {
  switch( action.type ) {
    case actions.FETCH_MATCH_EVENTS_SUCCEEDED:
      return Object.assign({}, state, processMatchEvents(action.data));
    case actions.FETCH_MATCH_EVENTS_DELTA_SUCCEEDED:
      return Object.assign({}, state, processMatchDeltaEvents(action.data, state));
    case actions.MATCH_PURGE:
      let newState: IMatchesState = Object.assign({}, state)
      if(newState[action.id]) {
        delete newState[action.id]
      }
      return newState
    default:
      return state;
  }
};

/*
 * Reducer setter
 */

const processMatchDeltaEvents = ( matchDeltaEventData: any, state: IMatchesState ) => {
  if ( !isFeadDataAvailable(matchDeltaEventData) ){
    return {};
  }

  const feedData = matchDeltaEventData.doc[0].data;
  const matchId: number = feedData.match._id;

  const match = {...state[matchId].match};
  const events = state[matchId].events.slice();
  const combinedEvents = events.concat(feedData.events);

  const scores = feedData.events.reduce( reduceEventsToMatch, { ...state[matchId].scores } );
  const teams = {...state[matchId].teams};
  const ranking = {...state[matchId].ranking};
  // const servingPlayer = {...state[matchId].servingPlayer}

  const lastEvent = feedData.events.length
    ? feedData.events[ feedData.events.length - 1 ]
    : events[ events.length - 1 ];

  const data = {
    match: {...match},
    events: [...combinedEvents],
    scores: scores,
    ranking: ranking,
    // servingPlayer: servingPlayer,
    teams: teams,
    lastEvent: lastEvent
  };

  return { [matchId]: data };
};

const processMatchEvents = ( matchEventData: IMatchEventsFeed ) => {
  if ( !isFeadDataAvailable(matchEventData) ){
    return {};
  }

  const match: IMatchEventMatch = matchEventData.doc[0].data.match;
  const events: IMatchEvent[] = matchEventData.doc[0].data.events;

  const scores = events.reduce( reduceEventsToMatch, { ...generateEmptyScores() } );

  const data = {
    events: events,
    match: match,
    scores: scores,
    teams: match.teams,
    ranking: { home: 0, away: 0 }, // TODO: dummy data have to be replaced by a real implementation
    //servingPlayer: '', //"home" || "away"  // TODO: dummy data have to be replaced by a real implementation
    lastEvent: events[ events.length - 1 ]
  };

  return { [match._id]: data }
};

const reduceEventsToMatch = ( before: any, event: IMatchEvent ) => {
  const typeId: string = event._typeid;

  before.period = event.period ? event.period : before.period;

  before.winnerDetermined = false;

  switch( typeId ) {
    // set initially serving player
    case eventTypes.INITIALLY_SERVING_PLAYER:

      // initial state
      before.servingPlayer = event.team;
      nthObject[event.matchid] = { 
        nthSetCounter: 1, 
        nthGameCounter: 1, 
        nthPointCounter: 1,

        // we want to display gamenumbers per set now - not continious anymore (LiveScoreSubtitleView)
        nthGameCounterOfSet: 1,

      };
      break;
    case eventTypes.SCORE_CHANGE_TENNIS:
      // at the moment we need to count the number of points ourselves so after every event add 1
      if(nthObject[event.matchid].nthPointCounter) {
        nthObject[event.matchid].nthPointCounter = nthObject[event.matchid].nthPointCounter+1;
      } 

      let tieBreak = (event.game_score.home == "6" && event.game_score.away =="6") ? 1 : 0;

      // add latest game_points
      const last_game_points = before.game_points;
      if(last_game_points.last_game_points) {
        // delete last_game_points.last_game_points
      }
      before.game_points = mapGameScore( {...event.game_points}, tieBreak );
      before.game_points.last_game_points = last_game_points;

      // update set status
      before.game_points.tieBreak = tieBreak;

      before.game_score = {...event.game_score};
      before.set_score = {...event.set_score};

      before.game_score.pointflag = event.pointflag;

      // with every score event know who will serve the next ball (1 == home, 2 == away)
      event.service == "1" ? before.servingPlayer = "home" : before.servingPlayer = "away";

      // add pointflag info, vgpointflagtranslation has been created especially for VTI, the "real" feed does not
      // fill this property
      before.game_score.pointflagtranslation = event.vgpointflagtranslation ? event.vgpointflagtranslation: '';

      // add team info (who caused the score change)
      before.game_score.team = event.team;

      // a set has been won by a player
      if(event.pointflag == "Set" ) {
        // currentSet is set in periodscore events (FIRST_SET, SECOND_SET, THIRD_SET)
        before.periodScores[before.periodScores.currentSet].winner = event.team;

        // as we don't have an event for a set start we set the default scores for set currentSet+1 by hand
        if(before.periodScores.currentSet <3) {
          before.periodScores.currentSet2 = before.periodScores.currentSet+1;
        }
      }

      // to prevent an infinitely increasing number of matchids in this object we remove
      // the current matchid at the end of the match
      if(event.pointflag == "Match") {
        delete nthObject[event.matchid];
      }

      break;
    case eventTypes.PERIOD_START:

      // we found a set start, now we set the default score to 0:0 for this set
      let periodScore = before.periodScores[event.period];
      periodScore.home = 0;
      periodScore.away = 0;

      // reset number of games per set
      nthObject[event.matchid].nthGameCounterOfSet = 1;

      // set setcounter
      nthObject[event.matchid].nthSetCounter = event.period;
      //console.log('m'+event.matchid, 'PERIOD_START', nthObject[event.matchid].nthSetCounter)

      break;
    // this means a periodscore in one of the sets, NOT the beginning of a set!!!
    case eventTypes.FIRST_SET:
    case eventTypes.SECOND_SET:
    case eventTypes.THIRD_SET:

      // always refresh the currently running set (used to set periodScore in score_change_tennis event above)
      before.periodScores.currentSet = event.period;

      // If a player won then set the score to '-', otherwise
      // reset the score to 0:0
      if(event.result.home == "2" || event.result.away == "2") {
        before.game_points = Object.assign({}, before.game_points, {
          away: "-",
          home: "-",
        });
        before.winnerDetermined = true;
      } else {
        before.game_points = Object.assign({}, before.game_points, {
          away: 0,
          home: 0,
          tieBreak: 0
        });
      }

      // game is over, reset nthPoint counter
      if(nthObject[event.matchid] && nthObject[event.matchid].nthPointCounter){
        nthObject[event.matchid].nthPointCounter = 1;
      }

      // game is over, increase number of games by 1
      if(nthObject[event.matchid] && nthObject[event.matchid].nthGameCounter){
        nthObject[event.matchid].nthGameCounter = nthObject[event.matchid].nthGameCounter+1;
      }

      // game is over, increase number of games per set by 1
      if(nthObject[event.matchid] && nthObject[event.matchid].nthGameCounterOfSet){
        nthObject[event.matchid].nthGameCounterOfSet++;
      }

      before.periodScores[event.period] = {
        ...before.periodScores[event.period],
        ...event.periodscore
      };
      break;
    case eventTypes.MATCH_END:
      // Reset game score after match has ended but next match
      // isn't active yet - i.e. old match is still visible in
      // the matchlist.
      before.game_points = {
        away: '-',
        home: '-',
        tieBreak: 0
      };
      before.winnerDetermined = true;
      break;

    default:
  }

   // only if data is available (isn't the case on startup)
  if(nthObject[event.matchid]) {
    // add the counted number of games to game_score property
    before.game_score.nthGameCounter = nthObject[event.matchid].nthGameCounter;

    // add the counted number of points to game_points property
    before.game_points.nthPointCounter = nthObject[event.matchid].nthPointCounter;

    // we want to display gamenumbers per set now - not continious anymore (LiveScoreSubtitleView)
    before.game_score.nthGameCounterOfSet = nthObject[event.matchid].nthGameCounterOfSet;

    // 
    before.game_score.nthSetCounter = nthObject[event.matchid].nthSetCounter;

  }
  return before
}

// map points from feed to readable "real" points
const mapGameScore = (gamePoints: any, tieBreak:number) =>  {

  let mappedGameScore : { home?: any, away?: any } = {};


  // if a tie break is played the data won't be mapped
  if (tieBreak == 1) {
    return gamePoints;
  }

  // if a score is bigger than 2 to 2 but one of the player is a score ahead this player gets an "A" for the advantage
  if ((gamePoints.home > 2 && gamePoints.away > 2) && gamePoints.home != gamePoints.away) {
    mappedGameScore.home = gamePoints.home > gamePoints.away ? 'A' : 40;
    mappedGameScore.away = gamePoints.away > gamePoints.home ? 'A' : 40;
  }

  // if a score is bigger than 2 to 2 it can only be a 40 to 40
  else if ((gamePoints.home > 2 && gamePoints.away > 2)) {
    mappedGameScore.home = 40;
    mappedGameScore.away = 40;
  }
  // if both player have less than 5 scores the data can be mapped with the map object("mapScoreObject")
  // e.g. a 1 to 1 get mapped to 15 to 15
  // we need to handle 4 (actually a won game) as well as it has to be displayed like 3 ("40")
  else if ( gamePoints.home <= 4 && gamePoints.away <= 4 ) {
    mappedGameScore.home = mapScoreObject[gamePoints.home];
    mappedGameScore.away = mapScoreObject[gamePoints.away];
  }

  // adjust content if necessary
  // value should be 0 or bigger (15, 30, 40) or "A" for advantage, these are the possible mapped values
  // we also need to check on !null as null is handled like 0 - content of mappedGameScore[home/away] can be just an empty string
  mappedGameScore.home = ((mappedGameScore.home >= 0 || mappedGameScore.home == "A") && mappedGameScore.home != null) ?
      mappedGameScore.home : '-';

  mappedGameScore.away = ((mappedGameScore.away >= 0 || mappedGameScore.away == "A") && mappedGameScore.away != null) ?
      mappedGameScore.away : '-';
  
  return mappedGameScore;
};

/*
 * Reducer getter
 */

// returns 1 if set is in tie break or 0 if it isn't (or no data is available)
export const getSetStatus = (state:IState, matchId:any) => {
    return state.matches[matchId] && state.matches[matchId].scores ? 
		state.matches[matchId].scores.game_points.tieBreak : 0;
};

export const getTournamentId = ( state: IState ) => {
   const matches = getMatches( state );

   return matches.reduce( ( aggregate: number, match: any ) => {
     if( match.match._tid > aggregate ) {
       aggregate = match.match._tid;
     }

     return aggregate;
   }, 0)
 };

export const getUniqueTournamentId = ( state: IState ) => {
  const matches = getMatches( state );

  return matches.reduce( ( aggregate: number, match: any ) => {
    if( match.match._utid > aggregate ) {
      aggregate = match.match._utid;
    }

    return aggregate;
  }, 0)
};

export const getSeasonId = ( state: IState ) => {
  const matches = getMatches( state );

  return matches.reduce( ( aggregate: number, match: any ) => {
    if( match.match._seasonid > aggregate ) {
      aggregate = match.match._seasonid;
    }

    return aggregate;
  }, 0)
}
 export const getPlayerNameByPlayerId = ( state: IState, playerId: number ) => {
   const player = getPlayerByPlayerId( state, playerId );

   return testDataAndReturnData( player, '_id' )
 };

 export const getPlayerAbbreviationByPlayerId = ( state: IState, playerId: number ) => {
   const player = getPlayerByPlayerId( state, playerId );

   return testDataAndReturnData( player, 'abbr' )
 };

 export const getLastEventIdByMatchId = ( state: IState, matchId: number ) => {
   const events = getEventsByMatchId( state, matchId );
   const event = testDataAndReturnData( events, ( events.length - 1 ) );

   return testDataAndReturnData( event, '_id' );
 };

 export const getSRPlayerIdsByMatchId = ( state: IState, matchId: number ) => {
   const players = getPlayersByMatchId( state, matchId );

   return testHomeAndAwayDataAndReturnData( players, 'uid' )
 };

 export const getRankingsByMatchId = ( state: IState, matchId: number ) => {
   const match = getMatchByMatchId( state, matchId );

   return testDataAndReturnData( match, 'ranking' )
 };

 export const getTeamNamesByMatchId = ( state: IState, matchId: number ) => {
   const players = getPlayersByMatchId( state, matchId );

   return testHomeAndAwayDataAndReturnData( players, 'name' )
 };

 export const getTeamAbbreviationNamesByMatchId = ( state: IState, matchId: number ) => {
   const players = getPlayersByMatchId( state, matchId );

   return testHomeAndAwayDataAndReturnData( players, 'abbr' )
 };

  export const getPlayerIdsByMatchId = ( state: IState, matchId: number ) => {
    const players = getPlayersByMatchId( state, matchId );

    return testHomeAndAwayDataAndReturnData( players, '_id' )
  };

  export const getPlayerUidsByMatchId = ( state: IState, matchId: number ) => {
    const players = getPlayersByMatchId( state, matchId );

    return testHomeAndAwayDataAndReturnData( players, 'uid' )
  };

  export const getPeriodScoresByMatchId = ( state: IState, matchId: number ) => {
    const scores = getScoresByMatchId( state, matchId );

    return testDataAndReturnData( scores, 'periodScores' )
  };

 export const getGamePointsByMatchId = ( state: IState, matchId: number ) => {
   const scores = getScoresByMatchId( state, matchId );

   return testDataAndReturnData( scores, 'game_points' )
 };

 export const getGameScoreByMatchId = ( state: IState, matchId: any ) => {
   const scores = getScoresByMatchId( state, matchId );

   return testDataAndReturnData( scores, 'game_score' )
 };

 export const getServingPlayerByMatchId = ( state: IState, matchId: number ) => {
   const scores = getScoresByMatchId( state, matchId );

   return testDataAndReturnData( scores, 'servingPlayer' )
 };

 export const getServingPlayerIdByMatchId = ( state: IState, matchId: number ) => {
   const servingPlayer = getServingPlayerByMatchId( state, matchId );
   const players = getTeamsByMatchId( state, matchId );

   return testDataAndReturnData( players[servingPlayer], '_id' )
 };

 export const getPeriodByMatchId = ( state: IState, matchId: number ) => {
   const scores = getScoresByMatchId( state, matchId );

   return testDataAndReturnData( scores, 'period' )
 };

export const getWinnerDeterminedByMatchId = (state: IState, matchId: number) => {
  const scores = getScoresByMatchId(state, matchId);
  return testDataAndReturnData(scores, 'winnerDetermined');
};

export const getMatchesMatchIds = (state: IState) => {
  return Object.keys(state.matches).map((matchId: string) => Number(matchId));
};

/*
 * Reducer helper
 */
const testDataAndReturnData = ( data: any, propertyName: any ) => {
  try{
    return data[ propertyName ]
  } catch ( err ) {
    // console.error(' something went wrong ', err)
    return null;
  }
};

const testHomeAndAwayDataAndReturnData = ( data: any, propertyName: any ) => {
  try{
    return {
      home: data.home[ propertyName ],
      away: data.away[ propertyName ]
    }
  } catch ( err ) {
    // console.error(' something went wrong ', err)
    return generateEmptyHomeOrAway();
  }
};

const getPlayerByPlayerId = ( state: IState, playerId: number ) => {
  const teams = getTeams( state );

  return teams.find( ( team: any ) => team._id === playerId );
};

const getTeamsByMatchId = ( state: IState, matchId: number ) => {
  const match = getMatchByMatchId( state, matchId );

  return match.teams;
};

const getScoresByMatchId = ( state: IState, matchId: number ) => {
  const match = getMatchByMatchId( state, matchId );

  return match.scores;
};

const getEventsByMatchId = ( state: IState, matchId: number ) => {
  const match = getMatchByMatchId( state, matchId );

  return match.events;
};

const getPlayersByMatchId = ( state: IState, matchId: number ) => {
  const match = getMatchByMatchId( state, matchId );

  return match.teams;
};

const getMatchByMatchId = ( state: IState, matchId: number ) => {
  const matches = state.matches;

  if( matches[ matchId ] ) {
    return matches[ matchId ];
  }

  return generateEmptyMatch();
};

const getTeams = ( state: IState ) => {
  const matches = getMatches( state );
  return matches
    .map( match => match.teams )
    .reduce( ( aggregate: any, teams: any ) => {
      if( teams.home ) {
        aggregate.push( teams.home );
      }

      if( teams.away ) {
        aggregate.push( teams.away );
      }

      return aggregate
    }, []);
};

const getMatches = ( state: IState ) => {
  return Object.values( state.matches );
};

const getDataByMatchId = ( data: any, matchId: number ) => {
  if( data[ matchId ] ) {
    return data[ matchId ];
  }

  const defaultData = data[ 0 ];

  return Object.keys( defaultData ).reduce( ( aggregate: any, key: string ) => {
    let value = {};

    if( defaultData[ key ].home || defaultData[ key ].away ) {
      value = {
        home: null,
        away: null
      };
    }

    aggregate[ key ] = value;

    return aggregate;
  }, {});
};

/*
 * Reducer helper
 */

const getHomeAwayPropertyGroupedByMatchIds = ( objects: any, propertyName: string ) => {
  return Object.keys(objects).reduce( ( before: any, key: string ) => {
    let value = objects[ key ];

    let homeAwayValue = {
      home: value.home[ propertyName ],
      away: value.away[ propertyName ]
    };

    before[ key ] = homeAwayValue;

    return before
  }, {});
};

const getPropertyGroupedByMatchIds = ( objects: any, propertyName: string ) => {
  return Object.keys(objects).reduce( ( before: any, key: string ) => {
    let value = objects[ key ];

    before[ key ] = value[ propertyName ];

    return before;
  }, {});
};

const isFeadDataAvailable = ( data: any ) => data.doc[0].data ? true : false;

const generateEmptyMatch = () => {
  const match = {
    events: [],
    lastEvent: null,
    match: null,
    rank: { ...generateEmptyHomeOrAway() },
    scores: { ...generateEmptyScores() },
    teams: {... generateEmptyHomeOrAway() },
  };

  return match;
};

const generateEmptyHomeOrAway = () => {
  const homeOrAway = { home: null, away: null };

  return homeOrAway;
};

const generateEmptyScores = () => {
  const periodScoreStructure = {
    [1]: {
      winner: '',
      ...generateEmptyHomeOrAway()
    },
    [2]: {
      winner: '',
      ...generateEmptyHomeOrAway()
    },
    [3]: {
      winner: '',
      ...generateEmptyHomeOrAway()
    },
    'currentSet': 1
  };

  const scores = {
    game_points: {
      //...generateEmptyHomeOrAway(),
      home: '-',
      away: '-',
      tieBreak: null
    },
    game_score: generateEmptyHomeOrAway(),
    set_score: generateEmptyHomeOrAway(),
    periodScores: { ...periodScoreStructure },
    period: 1,
    servingPlayer:  null,
  };
  
  return scores;
};

export default matches;
